import React, { useContext } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import { ThemeOptions } from '@wix/da-shared-react/pkg/publicSession/types';
import { ThemeContext } from '@wix/da-shared-react/pkg/Context/ThemeContext';
import DealerAd from '@wix/da-shared-react/pkg/DealerAd';
import FeedPostbox from './FeedPostbox';
import FeedNotice from './FeedNotice';
import s from './FeedLayout.scss';

export interface Props {
  children?: React.ReactNode;
}

const sidebarDealerSlots = {
  [ThemeOptions.DARK]: [
    '8aa7fae2-9420-434c-adf2-8154f4caad22',
    'b2601b3d-5909-4185-9243-27ed699751a2',
  ],
  [ThemeOptions.LIGHT]: [
    'e1a5ac5d-261a-4aa7-89a9-04f3f634bb14',
    '40311e52-55a0-4508-a8ea-084269520982',
  ],
};

const FeedLayout: React.FC<Props> = ({ children }) => {
  const theme = useContext(ThemeContext);
  const isMobile = useContext(MobileContext);

  const adslots = (theme && sidebarDealerSlots[theme]) ?? [];

  return (
    <div className={s['root']}>
      <div className={s['feed-wrapper']}>
        <div className={s['feed']}>
          <FeedPostbox className={s['feed-postbox']} />
          <FeedNotice className={s['feed-item']} />
          <div className={s['feed-item']}>{children}</div>
        </div>

        {!isMobile && (
          <div className={s['sidebar']}>
            <div className={s['sidebar-sticky']}>
              {adslots.map(realEstateId => (
                <DealerAd
                  key={realEstateId}
                  realEstateId={realEstateId}
                  className={cn(s['sidebar-block'], s['dealer'])}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
FeedLayout.displayName = 'FeedLayout';

export default FeedLayout;
